import { Validation } from "constants/Validation";
import * as Yup from "yup";
import { msgTypes } from "constants/msgTypes";

export const MailRequestSchema = Yup.object({
    // from: Yup.string(),//.required(Validation.required.message.replaceAll("^","From"))
    // //.matches(Validation.email.regex, Validation.email.message),
    // to: Yup.string(),
    // cc: Yup.string(),//.matches(Validation.cc.regex, Validation.cc.message),
    // bcc: Yup.string(),//.matches(Validation.cc.regex, Validation.cc.message),
    subject: Yup.string().required(Validation.required.message.replaceAll("^", "Subject"))
        .matches(Validation.plaintext.regex, Validation.plaintext.message),
    // body: Yup.string().required(Validation.required.message.replaceAll("^", "Body")),
    // .matches(Validation.plaintext.regex, Validation.plaintext.message),

    attachment: Yup.array().of(
        Yup.object().shape({
          file: Yup.mixed().nullable()
            // .test(
            //   "FILE_FORMAT",
            //   msgTypes.IMAGE_UNSUPPORTED_FORMAT,
            //   (value) => !value || (value && [msgTypes.IMAGE_FORMAT.JPEG,
            //     msgTypes.IMAGE_FORMAT.JPG, msgTypes.IMAGE_FORMAT.PNG, msgTypes.IMAGE_FORMAT.WEBP,msgTypes.IMAGE_FORMAT.SVG,  
            //     msgTypes.IMAGE_FORMAT.PDF, msgTypes.IMAGE_FORMAT.CSV, msgTypes.IMAGE_FORMAT.EXCEL,msgTypes.IMAGE_FORMAT.WORD].includes(value?.type))
            // )
            .test(
              "FILE_SIZE",
              msgTypes.FILE_SIZE_MESSAGE_3MB,
              (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
            ),
        })
      ),
    // attachment: Yup.mixed().nullable()
    //     .test(
    //         "FILE_FORMAT",
    //         msgTypes.IMAGE_UNSUPPORTED_FORMAT,
    //         (value) => !value || (value && [msgTypes.IMAGE_FORMAT.PDF
    //         ].includes(value?.type))
    //     )
    //     .test(
    //         "FILE_SIZE",
    //         msgTypes.FILE_SIZE_MESSAGE_3MB,
    //         (value) => !value || (value && value.size <= msgTypes.FILE_SIZE_3MB)
    //     ),


})
